import CloseIcon from '@mui/icons-material/Close';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import GroupIcon from '@mui/icons-material/Group';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  Link,
  Typography,
  TextField,
  Stack,
  Alert,
  Snackbar,
  Button,
  Autocomplete,
  Collapse,
  Tooltip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import PaidChange from 'src/components/PaidChange';
import {
  getCustomerHistory,
  getCustomersFromPhoneNumber,
  getRetailer,
  getMatchingConsumerInformation,
  getWebPointInvoiceDetail
} from 'src/store/slices/consumerInformationSlice';
import ChangeProductInfo from './ChangeProductInfo';
import FileInfo from './FileInfo';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DescriptionIcon from '@mui/icons-material/Description';
import Refund from 'src/components/Refund';
import AlertAndLoading from 'src/components/AlertAndLoading';
import { getUserRole } from 'src/utils/Common';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'src/utils/axios';
import { confirmAlert } from 'react-confirm-alert';
import { getReceiptInfoChat } from 'src/store/slices/informationChatSlice';
import {
  generalFollowActions,
  getDetail
} from 'src/store/slices/generalFollowSlice';
import { getUser } from 'src/utils/Common';
import React, { useEffect } from 'react';
import moment from 'moment';
import ArticleIcon from '@mui/icons-material/Article';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  div: {
    color: 'red',
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%'
  },
  div2: {
    fontSize: '12px',
    width: '100%',
    color: 'black'
  },
  icerikBilgi: {
    margin: '0px',
    fontWeight: '600',
    fontSize: '12px',
    lineheight: '1.43',
    letterspacing: '0.01071em',
    color: 'black',
    marginBottom: '7.5px'
  },
  tableCell: {
    fontWeight: '600',
    fontSize: '14px',
    color: 'black',
    whiteSpace: 'nowrap'
  },
  tableCellBilgi: {
    fontSize: '14px',
    color: 'black',
    whiteSpace: 'nowrap'
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 70,
    zIndex: 9,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  infoBox: {
    padding: '8px 8px',
    backgroundColor: '#fafafa',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
    marginBottom: '8px'
  },
  labelText: {
    fontWeight: '600',
    fontSize: '10px',
    color: '#757575',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px'
  },
  valueText: {
    fontSize: '11px',
    color: '#263238',
    fontWeight: '600'
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  spinning: {
    animation: '$spin 1s linear infinite'
  }
}));

function ConsumerInformation() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const Role = getUserRole().RoleId;
  const SessionUser = getUser();

  const [customerInfoPopUp, setCustomerInfoPopUp] = React.useState(false);
  const [webPointInvoicePopUp, setWebPointInvoicePopUp] = React.useState(false);
  const [customerInvoicePdfPopUp, setCustomerInvoicePdfPopUp] =
    React.useState(false);
  const [retailerInfoPopUp, setRetailerInfoPopUp] = React.useState(false);
  const [consumerInfoPopUp, setConsumerInfoPopUp] = React.useState(false);
  const [currentConsumerInfoPopUp, setCurrentConsumerInfoPopUp] =
    React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const [refreshing, setRefreshing] = React.useState(false);

  const [retailerData, setRetailerData] = React.useState([]);
  const [consumerPhoneData, setConsumerPhoneData] = React.useState([]);
  const [currentConsumerData, setCurrentConsumerData] = React.useState([]);
  const [webPointInvoiceData, SetWebPointInvoiceData] = React.useState([]);

  const [
    matchingConsumerInformationPopUp,
    setMatchingConsumerInformationPopUp
  ] = React.useState(false);
  const [matchingConsumerInformation, setMatchingConsumerInformation] =
    React.useState([]);
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({
    ErrorType: 'error',
    ErrorTitle: 'Uyarı'
  });
  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const [text, setText] = React.useState(null);
  const [Info, setInfo] = React.useState('');
  const [TaxAdministrationData, setTaxAdministrationData] = React.useState('');
  const [IdentifyNumber, setIdentifyNumber] = React.useState(null);
  const [taxNumberUpdatePopUp, setTaxNumberUpdatePopUp] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const TaxNumOrIdentityNum = `${invoiceData[0]?.Consumer?.SSNGov}/${
    invoiceData[0]?.Consumer?.TaxNumber ||
    invoiceData[0]?.Consumer?.IdentityNumber
  }`;

  const [pdfUrl, setPdfUrl] = React.useState(null);
  const [ettnNumber, setEttnNumber] = React.useState('');

  const handleEditClick = () => {
    setTaxNumberUpdatePopUp(true);
    setIdentifyNumber(invoiceData[0]?.Consumer?.IdentityNumber);
    setText(invoiceData[0]?.Consumer?.TaxNumber);
    setInfo('');
    axios.get('/GetTaxAdministration', {}).then((response) => {
      setTaxAdministrationData(response.data);
    });
  };
  const handleSaveClick = () => {
    if (Info.length < 15) {
      InfoAlert('Açıklamanız 15 karakterden uzun olmalı ...', 'error', 'Uyarı');
      return;
    }
    if (IdentifyNumber.length != 0) {
      if (IdentifyNumber.length != 11) {
        InfoAlert(
          'TC kimlik numarası 11 karakter olmalı ...',
          'error',
          'Uyarı'
        );
        return;
      }
    }
    if (text.length != 0) {
      if (text.length != 10) {
        InfoAlert(
          'Vergi dairesi numarası 10 karakter olmalı ...',
          'error',
          'Uyarı'
        );
        return;
      }
    }
    if (text.length == 10 && selectedOption?.ID == 374) {
      InfoAlert(
        'Vergi dairesi numarası girdiğiniz için vergi dairesi TCKIMLIKNO olamaz.Lütfen Vergi dairesini değiştiriniz...',
        'error',
        'Uyarı'
      );
      return;
    }
    if (
      IdentifyNumber.length == 11 &&
      text.length == 0 &&
      selectedOption?.ID != 374
    ) {
      InfoAlert(
        ' TC kimlik numarası girdiğiniz için vergi dairesi TCKIMLIKNO olmalı.Lütfen Vergi dairesini değiştiriniz...',
        'error',
        'Uyarı'
      );
      return;
    }
    if (
      selectedOption?.ID == null ||
      selectedOption?.ID == '' ||
      selectedOption?.ID == undefined
    ) {
      InfoAlert('Lütfen Vergi Dairesi Seçiniz ...', 'error', 'Uyarı');
      return;
    }
    setTaxNumberUpdatePopUp(false);
    const data = {
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo,
      ServiceNumber: invoiceData[0]?.Exchange?.Service,
      CustomerNumber: invoiceData[0]?.Consumer?.Id,
      UserId: invoiceData[0]?.UserID,
      NewTaxNumber: text,
      Type: 1,
      NewCustomerType: 0,
      Desc: Info,
      TaxAdministrationId: selectedOption?.ID,
      NewIdentityNumber: IdentifyNumber
    };
    const data2 = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: invoiceData[0]?.Exchange?.Service,
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo
    };
    confirmAlert({
      message: 'Bu işlemi gerçekleştirmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            setLoading(true);
            axios
              .post('DiaUpdateCustomerTypeAndTaxNumber', data, {
                headers: { 'Content-Type': 'application/json' }
              })
              .then((response) => {
                if (response.data.ErrorCode === '0') {
                  InfoAlert(
                    'İşleminiz başarılıyla gerçekleşmiştir...',
                    'success',
                    'Başarılı'
                  );
                  setLoading(false);

                  var tempData = JSON.parse(JSON.stringify(invoiceData));
                  tempData[0].Consumer.TaxNumber = data.NewTaxNumber;
                  tempData[0].Consumer.IdentityNumber = data.NewIdentityNumber;
                  tempData[0].Consumer.TaxAdministrationId =
                    data.TaxAdministrationId;
                  tempData[0].Consumer.SSN =
                    data.NewTaxNumber || data.NewIdentityNumber;
                  tempData[0].Consumer.SSNGov =
                    selectedOption.ACIKLAMA || 'TCKIMLIKNO';
                  dispatch(generalFollowActions.updateNewData(tempData));

                  dispatch(
                    getReceiptInfoChat([
                      invoiceData[0]?.Exchange?.ApplyNo,
                      invoiceData[0]?.Exchange?.Service
                    ])
                  )
                    .then((response) => {})
                    .catch((err) => {
                      setLoading(false);
                      return;
                    });
                  setInfo('');
                  setIdentifyNumber(null);
                  setText(null);
                  setSelectedOption(null);
                  return;
                } else {
                  InfoAlert(response.data.ErrorDescription, 'error', 'Hata');
                  setLoading(false);
                  return;
                }
              })
              .catch((err) => {
                setLoading(false);
                return;
              });
          }
        },
        {
          label: 'Hayır',
          onClick: () => {}
        }
      ]
    });
  };

  const handleInfoChange = (event) => {
    setInfo(event.target.value);
  };

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  const handleIdentifyNumberChange = (event) => {
    setIdentifyNumber(event.target.value);
  };

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    });
    setUyari(true);
    return;
  }

  function getRetailerList(RetailerCode) {
    setRetailerInfoPopUp(true);
    setLoading(true);
    dispatch(getRetailer(RetailerCode)).then((response) => {
      if (response.payload?.length > 0) {
        setRetailerData(response.payload);
        setLoading(false);
      }
    });
  }

  function getConsumerPhoneList(Phone1) {
    setConsumerInfoPopUp(true);
    setLoading(true);
    dispatch(getCustomersFromPhoneNumber(Phone1)).then((response) => {
      if (response.payload?.length > 0) {
        setConsumerPhoneData(response.payload);
        setLoading(false);
      }
    });
  }

  function getCustomerHistoryList(CustomerNumber) {
    setCurrentConsumerInfoPopUp(true);
    setLoading(true);
    dispatch(getCustomerHistory(CustomerNumber))
      .then((response) => {
        setCurrentConsumerData([]);
        setLoading(false);
        if (response?.payload && response.payload.length > 0) {
          setCurrentConsumerData(response.payload);
        } else {
          InfoAlert('Müşteri geçmişi bulunamadı.', 'warning', 'Bilgilendirme');
        }
      })
      .catch((err) => {
        setLoading(false);
        setCurrentConsumerInfoPopUp(false);
        InfoAlert(
          'Müşteri bilgileri yüklenirken bir hata oluştu.',
          'error',
          'Hata'
        );
      });
  }

  function getMatchingConsumerInformationClick(FisNo) {
    setLoading(true);
    dispatch(getMatchingConsumerInformation(FisNo)).then((response) => {
      if (response.payload?.length > 0) {
        setMatchingConsumerInformationPopUp(true);
        setMatchingConsumerInformation(response.payload[0]);
        setLoading(false);
      } else {
        setMatchingConsumerInformationPopUp(false);
        setLoading(false);
        InfoAlert('Fiş Bilgileri Bulunamadı!...', 'error', 'Hata');
        return;
      }
    });
  }

  function getWebPointInvoiceDetailClick(FisNo) {
    setLoading(true);
    dispatch(getWebPointInvoiceDetail(FisNo))
      .then((response) => {
        SetWebPointInvoiceData([]);
        if (response.payload.length > 0) {
          SetWebPointInvoiceData(response?.payload);
        }
        setWebPointInvoicePopUp(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const handleOpenCustomerInvoicePDF = (ReceiptNumber) => {
    setLoading(true);
    axios
      .get(`/GetCustomerInvoicePDF/${ReceiptNumber}`, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode == '0') {
          const ettnNumber = data.EttnNumber;
          const base64Pdf = data.Base64Pdf;
          const byteCharacters = atob(base64Pdf);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          setEttnNumber(ettnNumber);
          setCustomerInvoicePdfPopUp(true);
          setLoading(false);
          return () => {
            URL.revokeObjectURL(url);
          };
        } else {
          InfoAlert(data.ErrorMessage, 'error', 'Hata');
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSendSmsCustomerInvoicePdf = (ReceiptNumber, EttnNumber) => {
    const data = {
      receiptNumber: ReceiptNumber,
      ettnNumber: EttnNumber,
      SessionUser: SessionUser?.UserId
    };
    setLoading(true);
    axios
      .post('SetCustomerInvoicePdfSendSms', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        if (response.data.ErrorCode == '0') {
          dispatch(
            getReceiptInfoChat([
              invoiceData[0]?.Exchange?.ApplyNo,
              invoiceData[0]?.Exchange?.Service
            ])
          )
            .then((response) => {})
            .catch((err) => {
              return;
            });
          setCustomerInvoicePdfPopUp(false);
          setLoading(false);
          InfoAlert(
            'İşleminiz başarılıyla gerçekleşmiştir...',
            'success',
            'Başarılı'
          );
        } else {
          InfoAlert(response.data.ErrorDescription, 'error', 'Hata');
          setLoading(false);
        }
      })
      .catch((err) => {
        InfoAlert(
          'Gönderilemedi... Lütfen daha sonra tekrar deneyiniz...',
          'error',
          'Hata'
        );
        setLoading(false);
        return;
      });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleRefresh = () => {
    setRefreshing(true);
    const data = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: invoiceData[0]?.Exchange?.Service,
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo
    };
    dispatch(getDetail(data))
      .then(() => {
        setTimeout(() => setRefreshing(false), 500);
      })
      .catch(() => {
        setRefreshing(false);
      });
  };

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <AlertAndLoading
        Message={responseMessage}
        open={uyari}
        AlertType={alertType}
        onClose={uyariKapat}
        loading={loading}
      />
      <Card className={classes.mainCard}>
        <CardHeader
          className={classes.cardHeader}
          avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
          action={
            <Box sx={{ display: 'flex', gap: 1 }}>
              {invoiceData[0].Exchange.Status == 16 ||
              invoiceData[0].Exchange.Status == 17 ? (
                <Tooltip title="Fatura bilgilerini görüntüle">
                  <IconButton
                    onClick={() => {
                      handleOpenCustomerInvoicePDF(
                        invoiceData[0]?.Apply?.ReceiptNumber
                      );
                    }}
                    sx={{ color: '#FF9800' }}
                  >
                    <ArticleIcon />
                  </IconButton>
                </Tooltip>
              ) : null}
              <Tooltip title="Fatura Bilgileri">
                <IconButton
                  onClick={() => {
                    getWebPointInvoiceDetailClick(
                      invoiceData[0]?.Apply?.ReceiptNumber
                    );
                  }}
                  sx={{ color: '#FF9800' }}
                >
                  <DescriptionIcon />
                </IconButton>
              </Tooltip>
              {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
                <Tooltip title="Güncel Müşteri Bilgileri">
                  <IconButton
                    onClick={() => {
                      setCustomerInfoPopUp(true);
                    }}
                    sx={{ color: '#FF9800' }}
                  >
                    <GroupIcon />
                  </IconButton>
                </Tooltip>
              ) : null}
              <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                <IconButton
                  onClick={handleToggleCollapse}
                  sx={{ color: '#FF9800' }}
                >
                  {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          }
          title="Tüketici Bilgileri"
        />
        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          <CardContent sx={{ padding: '12px' }}>
            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Box className={classes.infoBox}>
                <Typography className={classes.labelText}>Ad Soyad</Typography>
                <Typography className={classes.valueText}>
                  {invoiceData[0]?.Consumer?.Name}
                </Typography>
              </Box>
            ) : (
              <Box className={classes.infoBox}>
                <Typography className={classes.labelText}>Ad Soyad</Typography>
                <Typography className={classes.valueText}>
                  {invoiceData[0]?.Retailer?.Name}
                </Typography>
              </Box>
            )}

            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Box className={classes.infoBox}>
                <Typography className={classes.labelText}>Telefon</Typography>
                <Typography className={classes.valueText}>
                  {invoiceData[0]?.Consumer?.Phone1}
                </Typography>
              </Box>
            ) : (
              <Box className={classes.infoBox}>
                <Typography className={classes.labelText}>Telefon</Typography>
                <Typography className={classes.valueText}>
                  {invoiceData[0]?.Retailer?.Phone1}
                </Typography>
              </Box>
            )}

            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Box
                className={classes.infoBox}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography className={classes.labelText}>
                    Vergi D./No
                  </Typography>
                  <Typography className={classes.valueText}>
                    {TaxNumOrIdentityNum}
                  </Typography>
                </Box>
                <Tooltip title="Vergi Numarası Düzenleme">
                  <IconButton
                    onClick={handleEditClick}
                    sx={{ color: '#FF9800' }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              <Box className={classes.infoBox}>
                <Typography className={classes.labelText}>
                  Vergi D./No
                </Typography>
                <Typography className={classes.valueText}>
                  {invoiceData[0]?.Retailer?.TaxAdministration +
                    '/' +
                    invoiceData[0]?.Retailer?.TaxNumber}
                </Typography>
              </Box>
            )}
            {invoiceData[0]?.Exchange?.ReasonForChangeConsumerInformation ? (
              <Box sx={{ marginTop: '16px' }}>
                <TextField
                  className={classes.div2}
                  id="input-with-icon-textfield"
                  label="Tüketici Bilgileri Değişiklik Sebebi"
                  size="small"
                  value={
                    invoiceData[0]?.Exchange?.ReasonForChangeConsumerInformation
                      ? invoiceData[0]?.Exchange
                          ?.ReasonForChangeConsumerInformation
                      : '-'
                  }
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={2}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px'
                    }
                  }}
                  inputProps={{
                    style: { fontSize: '11px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        position="end"
                        onClick={() =>
                          getMatchingConsumerInformationClick(
                            invoiceData[0]?.Apply?.ReceiptNumber
                          )
                        }
                      >
                        <PriorityHighIcon sx={{ color: 'red' }} />
                      </IconButton>
                    )
                  }}
                />
              </Box>
            ) : null}
          </CardContent>
        </Collapse>
      </Card>
      <Grid item xs={4} md={4} style={{ paddingTop: 10 }}></Grid>
      <ChangeProductInfo />
      <Grid item xs={4} md={4} style={{ paddingTop: 10 }}></Grid>
      <FileInfo />
      {Role?.filter((i) => i.ROLE_ID !== 11).length > 0 ? (
        <>
          <Grid item xs={12} style={{ paddingTop: 5 }}>
            <Refund />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: 10 }}>
            <PaidChange />
          </Grid>
        </>
      ) : null}

      {/* Garanti Başlatan Hizmet Fişi Müşteri Bilgileri PopUp*/}
      <Dialog
        open={matchingConsumerInformationPopUp}
        onClose={() => setMatchingConsumerInformationPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px',
            textAlign: 'center'
          }}
        >
          Garanti Başlatan Hizmet Fişi Müşteri Bilgileri
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '4px'
                  }}
                >
                  Garanti başlatan Hizmet Fiş no
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#263238'
                  }}
                >
                  {matchingConsumerInformation?.FIS_NO}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '4px'
                  }}
                >
                  Müşteri İsim Soyisim
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#263238'
                  }}
                >
                  {matchingConsumerInformation?.ADI}{' '}
                  {matchingConsumerInformation?.SOYADI}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '4px'
                  }}
                >
                  Müşteri Telefonu
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#263238'
                  }}
                >
                  {matchingConsumerInformation?.TEL1
                    ? matchingConsumerInformation?.TEL1
                    : '-'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '4px'
                  }}
                >
                  Müşteri Telefonu 2
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#263238'
                  }}
                >
                  {matchingConsumerInformation?.TEL2
                    ? matchingConsumerInformation?.TEL2
                    : '-'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '4px'
                  }}
                >
                  Faks Numarası
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#263238'
                  }}
                >
                  {matchingConsumerInformation?.FAKS
                    ? matchingConsumerInformation?.FAKS
                    : '-'}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setMatchingConsumerInformationPopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={customerInfoPopUp}
        onClose={() => setCustomerInfoPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <GroupIcon sx={{ fontSize: '18px' }} />
            Tüketici Bilgileri Detay
          </Box>
          <Tooltip title="Güncel Müşteri Kartı">
            <IconButton
              size="small"
              sx={{
                color: '#fff',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
              onClick={() =>
                getCustomerHistoryList(invoiceData[0]?.Consumer?.Id)
              }
            >
              <ContactMailIcon sx={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent
          sx={{ padding: '20px 24px 24px 24px', backgroundColor: '#fafafa' }}
        >
          <Grid container spacing={1}>
            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Grid item xs={12} sx={{ marginTop: '8px' }}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Ad Soyad
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#263238'
                    }}
                  >
                    {invoiceData[0]?.Consumer?.Name}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12} sx={{ marginTop: '8px' }}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Ad Soyad
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#263238'
                    }}
                  >
                    {invoiceData[0]?.Retailer?.Name}
                  </Typography>
                </Box>
              </Grid>
            )}

            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Telefon
                  </Typography>
                  <Link
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#FF9800',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }}
                    onClick={() =>
                      getConsumerPhoneList(invoiceData[0]?.Consumer?.Phone1)
                    }
                  >
                    {invoiceData[0]?.Consumer?.Phone2
                      ? invoiceData[0]?.Consumer?.Phone1 +
                        ' / ' +
                        invoiceData[0]?.Consumer?.Phone2
                      : invoiceData[0]?.Consumer?.Phone1}
                  </Link>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Telefon
                  </Typography>
                  <Link
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#FF9800',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }}
                    onClick={() =>
                      getConsumerPhoneList(invoiceData[0]?.Retailer?.Phone1)
                    }
                  >
                    {invoiceData[0]?.Retailer?.Phone2
                      ? invoiceData[0]?.Retailer?.Phone1 +
                        ' / ' +
                        invoiceData[0]?.Retailer?.Phone2
                      : invoiceData[0]?.Retailer?.Phone1}
                  </Link>
                </Box>
              </Grid>
            )}

            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Vergi D./No
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#263238'
                    }}
                  >
                    {invoiceData[0]?.Consumer?.SSNGov +
                      ' / ' +
                      invoiceData[0]?.Consumer?.SSN}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Vergi D./No
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#263238'
                    }}
                  >
                    {invoiceData[0]?.Retailer?.TaxAdministration +
                      ' / ' +
                      invoiceData[0]?.Retailer?.TaxNumber}
                  </Typography>
                </Box>
              </Grid>
            )}

            <Grid item xs={12}>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '8px 12px',
                  border: '1px solid #e0e0e0',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '3px'
                }}
              >
                <Typography
                  sx={{
                    fontSize: '9px',
                    fontWeight: '600',
                    color: '#757575',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}
                >
                  Bayi Adı/Kodu
                </Typography>
                <Link
                  sx={{
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#FF9800',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                  onClick={() => {
                    getRetailerList(invoiceData[0]?.Retailer?.Code);
                  }}
                >
                  {invoiceData[0]?.Retailer?.Code +
                    ' / ' +
                    invoiceData[0]?.Retailer?.Dsc}
                </Link>
              </Box>
            </Grid>

            {invoiceData[0]?.Consumer?.ConsumerType == 1 ||
            invoiceData[0]?.Consumer?.ConsumerType == 2 ? (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Adres
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '500',
                      color: '#263238',
                      lineHeight: '1.5'
                    }}
                  >
                    {invoiceData[0]?.Consumer?.Address}
                  </Typography>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '9px',
                      fontWeight: '600',
                      color: '#757575',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Adres
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: '500',
                      color: '#263238',
                      lineHeight: '1.5'
                    }}
                  >
                    {invoiceData[0]?.Retailer?.Addres}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setCustomerInfoPopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      {/*Bayi Bilgileri Detay popup başlangıcı */}

      <Dialog
        open={retailerInfoPopUp}
        onClose={() => setRetailerInfoPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px'
          }}
        >
          Bayi Bilgileri Detay
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Grid container spacing={2} sx={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <TableContainer
                sx={{
                  maxHeight: 440,
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  '& .MuiTable-root': {
                    backgroundColor: '#fff'
                  }
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800',
                          textAlign: 'center'
                        }}
                      >
                        Bayi Kodu
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Bayi Adı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Marka
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        İlgili Kişi
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Şehir
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Telefon1
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Telefon2
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {retailerData.map((row) => (
                      <TableRow
                        key={row.KUL_BAYI_KODU}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': {
                            backgroundColor: '#fff8f0'
                          }
                        }}
                      >
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.KUL_BAYI_KODU}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.ACIKLAMA}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.MARKA ? row.MARKA : '-'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SATISILGILIKISI ? row.SATISILGILIKISI : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SEHIR ? row.SEHIR : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.TEL1 ? row.TEL1 : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.TEL2 ? row.TEL2 : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setRetailerInfoPopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      {/*Telefon Bilgileri Detay popup başlangıcı */}
      <Dialog
        open={consumerInfoPopUp}
        onClose={() => setConsumerInfoPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px'
          }}
        >
          Telefon Bilgileri Detay
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Grid container spacing={2} sx={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <TableContainer
                sx={{
                  maxHeight: 440,
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  '& .MuiTable-root': {
                    backgroundColor: '#fff'
                  }
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Müşteri No
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Adı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Soyadı
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Birim Kodu
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Telefon
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Semt
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Şehir
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Adres
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Kayıt Tarihi
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {consumerPhoneData.map((row) => (
                      <TableRow
                        key={row.MUSTERI_NO}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': {
                            backgroundColor: '#fff8f0'
                          }
                        }}
                      >
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.MUSTERI_NO ? row.MUSTERI_NO : '-'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.ADI ? row.ADI : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SOYADI ? row.SOYADI : '-'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.BIRIM_KODU ? row.BIRIM_KODU : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.TEL1 ? row.TEL1 : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SEMT ? row.SEMT : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SEHIR ? row.SEHIR : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.ADRES ? row.ADRES : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.KAYIT_TARIHI ? row.KAYIT_TARIHI : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setConsumerInfoPopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      {/*Güncel Müşteri Kartı  */}
      <Dialog
        open={currentConsumerInfoPopUp}
        onClose={() => setCurrentConsumerInfoPopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px'
          }}
        >
          Güncel Müşteri Bilgileri
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Grid container spacing={2} sx={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <TableContainer
                sx={{
                  maxHeight: 440,
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  '& .MuiTable-root': {
                    backgroundColor: '#fff'
                  }
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800',
                          textAlign: 'center'
                        }}
                      >
                        Müşteri Durum
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Adı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Soyadı
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Adres
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Tel 1
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Tel 2
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        İl
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        İlçe
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Mahalle
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Vergi Dairesi
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Vergi Numarası
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Tarih
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentConsumerData?.map((row) => (
                      <TableRow
                        key={row.CustomerId}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': {
                            backgroundColor: '#fff8f0'
                          }
                        }}
                      >
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.CustomerType ? row.CustomerType : '-'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Name ? row.Name : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Surname ? row.Surname : '-'}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Adress ? row.Adress : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Tel1 ? row.Tel1 : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Tel2 ? row.Tel2 : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.City ? row.City : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Town ? row.Town : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.District ? row.District : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.TaxOffice ? row.TaxOffice : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Tckn ? row.Tckn : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.Date ? row.Date : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setCurrentConsumerInfoPopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={taxNumberUpdatePopUp}
        onClose={() => {
          setTaxNumberUpdatePopUp(false);
          setInfo('');
          setIdentifyNumber(null);
          setText(null);
          setSelectedOption(null);
        }}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px',
            textAlign: 'center'
          }}
        >
          Müşteri Tipi Değiştirme
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Box sx={{ marginTop: '16px' }}>
            <Grid item xs={12}>
              <TextField
                label="Tc Kimlik No"
                fullWidth
                size="small"
                value={IdentifyNumber}
                onChange={handleIdentifyNumberChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    fontSize: '11px'
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '11px'
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '16px' }}>
              <TextField
                label="Vergi Numarası"
                fullWidth
                size="small"
                value={text}
                onChange={handleTextChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    fontSize: '11px'
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '11px'
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '16px' }}>
              <Autocomplete
                options={TaxAdministrationData}
                getOptionLabel={(option) => option.ACIKLAMA}
                value={selectedOption}
                onChange={(event, newValue) => setSelectedOption(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    placeholder="Vergi Dairesi"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        fontSize: '11px'
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '16px' }}>
              <TextField
                label="Açıklama"
                fullWidth
                maxRows={5}
                size="small"
                multiline
                rows={3}
                value={Info}
                onChange={handleInfoChange}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    fontSize: '11px'
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '11px'
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={() => {
                  handleSaveClick();
                }}
                sx={{
                  backgroundColor: '#FF9800',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: '600',
                  fontSize: '12px',
                  padding: '8px 16px',
                  '&:hover': {
                    backgroundColor: '#F57C00'
                  }
                }}
              >
                Kaydet
              </Button>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => {
              setTaxNumberUpdatePopUp(false);
            }}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={webPointInvoicePopUp}
        onClose={() => setWebPointInvoicePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px'
          }}
        >
          Fatura Bilgileri
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          <Grid container spacing={2} sx={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <TableContainer
                sx={{
                  maxHeight: 440,
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  '& .MuiTable-root': {
                    backgroundColor: '#fff'
                  }
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Müşteri Adı Soyadı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        SAP Ürün Kodu
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Ürün Tanım
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Fatura Tarihi
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Fatura Numarası
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Satış Adeti
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Satış Tutarı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Bayi Kodu
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Bayi Ünvanı
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Vergi Dairesi
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        TC Kimlik Numarası
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        E Fatura Flag
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          fontWeight: '600',
                          fontSize: '10px',
                          color: '#424242',
                          padding: '8px 10px',
                          borderBottom: '2px solid #FF9800'
                        }}
                      >
                        Vergi Numarası
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {webPointInvoiceData?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': {
                            backgroundColor: '#fff8f0'
                          }
                        }}
                      >
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.ADSOYAD ? row.ADSOYAD : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SAP_URUN_KODU ? row.SAP_URUN_KODU : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.URUN_KISA_TANIM ? row.URUN_KISA_TANIM : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.FATURA_TARIHI
                            ? moment(row.FATURA_TARIHI).format('DD/MM/YYYY')
                            : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.FATURA_NO ? row.FATURA_NO : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SATIS_ADET ? row.SATIS_ADET : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.SATIR_TUTARI ? row.SATIR_TUTARI : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.BAYI_KODU ? row.BAYI_KODU : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.BAYI_UNVAN ? row.BAYI_UNVAN : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.VERGI_DAIRESI ? row.VERGI_DAIRESI : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.TC_KIMLIK_NO ? row.TC_KIMLIK_NO : '-'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.E_FATURA_FLAG === true ? '1' : '0'}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontSize: '11px',
                            padding: '8px 12px',
                            color: '#263238'
                          }}
                        >
                          {row.VERGI_NO ? row.VERGI_NO : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => setWebPointInvoicePopUp(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={customerInvoicePdfPopUp}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            fontWeight: '600',
            fontSize: '13px',
            padding: '10px 16px'
          }}
        >
          Fatura Bilgisi
        </DialogTitle>
        <DialogContent sx={{ padding: '20px', backgroundColor: '#fafafa' }}>
          {pdfUrl && (
            <iframe
              src={`${pdfUrl}#zoom=page-width`}
              title="Invoice PDF"
              style={{
                width: '100%',
                height: '700px',
                border: 'none',
                borderRadius: '12px'
              }}
            />
          )}
        </DialogContent>
        <DialogActions
          sx={{
            padding: '12px 20px',
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0',
            gap: '12px'
          }}
        >
          <Button
            onClick={() => {
              handleSendSmsCustomerInvoicePdf(
                invoiceData[0]?.Apply?.ReceiptNumber,
                ettnNumber
              );
            }}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#FF9800',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#F57C00'
              }
            }}
          >
            Sms Gönder
          </Button>
          <Button
            onClick={() => {
              setCustomerInvoicePdfPopUp(false);
            }}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#424242',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '12px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#616161'
              }
            }}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConsumerInformation;
